import React, { useState, useEffect, useRef } from 'react';
import './BottomDock.css';
import { useCart } from '../../context/CartContext';

const BottomDock = ({ setRoute }) => {
  const { getCartItemCount, openCart } = useCart();
  const cartCount = getCartItemCount();
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    let scrollTimeout;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Hide dock when scrolling down past threshold
      if (currentScrollY > lastScrollY.current && currentScrollY > 100) {
        setIsVisible(false);
      } 
      // Show dock when scrolling up
      else if (currentScrollY < lastScrollY.current) {
        setIsVisible(true);
      }

      lastScrollY.current = currentScrollY;

      // Clear existing timeout
      clearTimeout(scrollTimeout);

      // Show dock after user stops scrolling for 1.5 seconds
      scrollTimeout = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const handleNavClick = (route) => {
    if (setRoute && typeof setRoute === 'function') {
      setRoute(route);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleCartClick = () => {
    openCart();
  };

  return (
    <aside 
      className={`dock ${isVisible ? 'dock-visible' : 'dock-hidden'}`}
      role="complementary" 
      aria-label="Mobile navigation dock"
      aria-hidden={!isVisible}
    >
      <nav>
        <button 
          onClick={() => handleNavClick('home')}
          className="dock-item"
          aria-label="Go to home"
        >
          <i className="fas fa-home" aria-hidden="true"></i>
          <span>Home</span>
        </button>

        <button 
          onClick={() => handleNavClick('products')}
          className="dock-item"
          aria-label="View products"
        >
          <i className="fas fa-shopping-bag" aria-hidden="true"></i>
          <span>Shop</span>
        </button>

        <button 
          onClick={() => handleNavClick('recipes')}
          className="dock-item"
          aria-label="View recipes"
        >
          <i className="fas fa-utensils" aria-hidden="true"></i>
          <span>Recipes</span>
        </button>

        <button 
          onClick={handleCartClick}
          className="dock-item dock-cta"
          aria-label={`View cart with ${cartCount} items`}
        >
          <i className="fas fa-shopping-cart" aria-hidden="true"></i>
          <span>Cart</span>
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </button>
      </nav>
    </aside>
  );
};

export default BottomDock;
